var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRi3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Phone--application"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1H13V3H15V1Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4H13V6H15V4Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1H10V3H12V1Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4H10V6H12V4Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H12.415C2.59002 14.435 1.19503 6.145 1.00003 3.615C0.969521 3.21835 1.09783 2.82583 1.35674 2.52378C1.61564 2.22174 1.98392 2.03491 2.38057 2.0044C2.42021 2.00147 2.46003 2 2.50003 2H5.13503C5.3353 1.99981 5.53103 2.05975 5.69684 2.17208C5.86266 2.28441 5.99092 2.44393 6.06503 2.63L6.82503 4.5C6.8982 4.68177 6.91636 4.88104 6.87725 5.07305C6.83814 5.26505 6.74347 5.44134 6.60503 5.58L5.54003 6.655C5.70571 7.60066 6.15822 8.47249 6.83619 9.15226C7.51417 9.83202 8.3848 10.2868 9.33002 10.455L10.415 9.38C10.5558 9.24308 10.7337 9.15063 10.9267 9.11417C11.1196 9.07771 11.319 9.09887 11.5 9.175L13.385 9.93C13.5683 10.0064 13.7246 10.1357 13.8342 10.3013C13.9437 10.467 14.0014 10.6614 14 10.86V13.5C14 13.8978 13.842 14.2794 13.5607 14.5607C13.2794 14.842 12.8978 15 12.5 15ZM2.50003 3C2.43436 2.99979 2.3693 3.01251 2.30856 3.03745C2.24782 3.06238 2.19258 3.09903 2.146 3.14531C2.09942 3.1916 2.06242 3.2466 2.0371 3.30718C2.01178 3.36776 1.99863 3.43274 1.99843 3.4984C1.99843 3.5123 1.99893 3.52615 2.00003 3.54C2.23003 6.5 3.70502 13.5 12.47 14C12.6024 14.0079 12.7325 13.963 12.8317 13.875C12.9309 13.787 12.9911 13.6633 12.9991 13.5309C12.9997 13.5206 13 13.5103 13 13.5V10.86L11.115 10.105L9.68003 11.53L9.44002 11.5C5.09002 10.955 4.50003 6.605 4.50003 6.56L4.47002 6.32L5.89003 4.885L5.14003 3H2.50003Z",
    fill: "#B9D0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi3);
export default __webpack_public_path__ + "static/media/ri3.2041edfcedac3640b2d2badf8a97f6ff.svg";
export { ForwardRef as ReactComponent };